import React, { useEffect } from "react";
import Select, { SelectOption } from "@amzn/meridian/select";
import { useLocalizationContext } from "@amzn/react-arb-tools";
import { getLocalizationContext } from "../../../helpers";
import useLocaleContext from "src/components/shared/context/useLocaleContext";
import { LOCALES } from "src/constants";

const LanguagePicker = () => {
  const { setLocalizationContext } = useLocalizationContext();
  const { language, setLanguage } = useLocaleContext();

  useEffect(() => {
    setLocalizationContext(getLocalizationContext(language));
  }, [language])

  const handleChange = (language) => {
    setLanguage(language);
  };

  return (
    <Select
      value={language}
      onChange={(language) => handleChange(language)}
      placeholder="English(US)"
      width={130}
      size={"small"}
    >
      {LOCALES.map(({ langLable, langValue }, index) => (
        <SelectOption value={langValue} label={langLable} key={index} />
      ))}
    </Select>
  );
};

export default LanguagePicker;
